import { render, staticRenderFns } from "./LeftTextBrand.vue?vue&type=template&id=2472eb72&scoped=true"
import script from "./LeftTextBrand.vue?vue&type=script&lang=js"
export * from "./LeftTextBrand.vue?vue&type=script&lang=js"
import style0 from "./LeftTextBrand.vue?vue&type=style&index=0&id=2472eb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472eb72",
  null
  
)

export default component.exports